import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AiMarkupIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-markup'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_markup_index',
          component: AiMarkupIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
